export default "__VITE_ASSET__BeFykWdb__"